import { createContext } from "react";

export type DetailsContextProps = {
  id: string;
  isExpanded: boolean;
  expanded: () => void;
  close: () => void;
  toggle: () => void;
};

export const DetailsContext = createContext<DetailsContextProps>({
  id: "",
  isExpanded: false,
  expanded: () => undefined,
  close: () => undefined,
  toggle: () => undefined,
});
